import { ProjectElement } from '../../../../../app/resources/element/project-element.interface';
import { skip, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { ElementChange, ElementLogs } from '../../../../../app/resources/log/logs.interface';

(function() {
  angular
    .module('specsguardApp')
    .controller('widgetProjectLogCtrl', widgetProjectLogCtrl);

  widgetProjectLogCtrl.$inject = ['Labels', 'sg2ElementSidebarService', 'sg2ProjectService', 'sg2ElementService', 'sg2LogService'];

  function widgetProjectLogCtrl (Labels, sg2ElementSidebarService, sg2ProjectService, sg2ElementService, sg2LogService) {

    const vm = this;

    /** Labels. */
    vm.LABELS = Labels;

    /** Logs. */
    vm.logs = [];

    /** Log limit. */
    vm.LOG_LIMIT = 25;

    /** Initialize project. */
    vm.project = JSON.parse(JSON.stringify(sg2ProjectService.get()));

    /** Add lifecycle hook for unsubscribe. */
    const destroy$ = new Subject();

    /**
     * Get changes.
     */
    sg2LogService.getLogs().subscribe((logs: ElementLogs) => {
      vm.setLogs(JSON.parse(JSON.stringify(logs.changes)));
    });

    /** Subscribe to project updates. */
    sg2ProjectService.project$.pipe(
      skip(1),
      takeUntil(destroy$)
    ).subscribe(p => {
      vm.project = JSON.parse(JSON.stringify(p));
      sg2LogService.getLogs().subscribe((logs: ElementLogs) => {
        vm.setLogs(JSON.parse(JSON.stringify(logs.changes)));
      });
    });

    /** Unsubscribe. */
    vm.$destroy = () => {
      destroy$.next();
      destroy$.complete();
    };

    /**
     * Set logs.
     *
     * @param changes Array of element changes.
     */
    vm.setLogs = (changes: ElementChange[]): void => {
      const logs = [];
      for (const change of changes) {
        logs.push(change);
      }
      vm.logs = logs;
    };

    /**
     * Open selected element in sidebar.
     *
     * @param identifier Selected element identifier.
     */
    vm.openSidebar = (change: ElementChange): void => {
      const element = sg2ElementService.getElement(change.elementId, { constructionId: change.constructionId });
      sg2ElementSidebarService.open(element, 'history');
    };
  }
})();
